import {
  Component, ViewEncapsulation, OnInit, ViewChild, ViewContainerRef, Injectable
} from '@angular/core';
import { CanActivate, CanActivateChild, NavigationError, NavigationStart, Router } from '@angular/router';
import { ApiService } from './api/api-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  public title = 'MOVISAT - Importación EcoSAT';
  public urlOrigin = '';
  public urlApiSSO = '';
  public webSSO = '';

  @ViewChild('mainContainer', { read: ViewContainerRef }) mainContainer;
  private static instance: AppComponent;

  constructor(private router: Router, private apiService: ApiService) {
    AppComponent.instance = this;
    setTimeout(async () => {
      this.urlOrigin = new URLSearchParams(window.location.search).get('origin');
      if (!this.urlOrigin) {
        this.urlOrigin = sessionStorage.getItem('eco-import-origen');
        if (!this.urlOrigin) {
          this.urlOrigin = '';
        }
      }
      // Compruebo la URL de origen
      if (this.urlOrigin.startsWith('my.movisat.com')) {
        this.urlApiSSO = 'https://api.sso.movisat.com';
        this.webSSO = 'https://my.movisat.com';
      } else {
        if (this.urlOrigin.startsWith('preproduccion.my.movisat.com')) {
          this.urlApiSSO = 'https://api.sso.preproduccion.movisat.com';
          this.webSSO = 'https://preproduccion.my.movisat.com';
        } else {
          this.urlApiSSO = 'https://api.sso.dev.movisat.com';
          this.webSSO = 'https://dev.my.movisat.com';
        }
      }
      sessionStorage.setItem('eco-import-origen', this.urlOrigin);
      // Antes de nada pido el token del SSO para que se almacene en el localstorage
      await this.apiService.getSSOApiToken();
      // Control de eventos de enrutamiento
      this.router.events.subscribe(async (event) => {
        // Cada vez que se carga una página
        if (event instanceof NavigationStart) {
          if (!event.url.startsWith('/?ticketId=')) {
            // Se cormprueba que hay ticket SSO válido
            const ticket = this.apiService.getTicket();
            if (ticket === null || !await this.apiService.isUsuarioValidado(ticket.Usuario.Id)) {
              this.logout();
            }
          }
          // Si se accede a una página que no existe
          if (event instanceof NavigationError) {
            this.logout();
          }
        }
      });
      // Si no tengo el ticket del SSO intento recuperarlo
      const ticketId = new URLSearchParams(window.location.search).get('ticketId');
      if (ticketId || !this.apiService.getTicket()) {
        setTimeout(async () => {
          // Recupero el ticket del SSO con el id recibido
          if (await this.apiService.initSession(ticketId)) {
            this.login();
          } else {
            this.logout();
          }
        }, 0);
      } else {
        if (window.location.pathname === '/') {
          this.logout();
        }
      }
    }, 0);
  }

  ngOnInit(): void {
  }

  onRightClick(event) {
    event.preventDefault();
  }

  public static getInstance(): AppComponent {
    return AppComponent.instance;
  }

  // Redirijo a la página principal
  private async login(): Promise<void> {
    // Abro el componente principal de la aplicación
    this.router.navigateByUrl('main');
  }

  // Redirijo a la página de login del SSO
  private logout(): void {
    this.apiService.endAppSession();
  }

}

// Clase que sirve para comtrolar todas las redirecciones
// Si no hay ticket del SSO no dejo redireccionar a ninguna página
@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private apiService: ApiService) { }

  canActivate() {
    return this.apiService.getTicket() !== null;
  }

  canActivateChild() {
    return this.apiService.getTicket() !== null;
  }

}
